import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'
import { IndigoHeader } from './IndigoHeader';

const styles: { [key: string]: React.CSSProperties } = {
    // Container Styles
    container: {
        minHeight: '100vh', // Ensure it covers the full viewport height
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: 'linear-gradient(to bottom, #f7f8fa, #e3e6ea)', // Soft gradient background
    },
    errorMessage: {
        color: 'red',
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '10px',
    },
    registerBox: {
        marginTop: '20px',
        width: '90%',
        marginBottom: '10vh',
        maxWidth: '550px',
        padding: '30px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)', // Slight transparency for blend effect
        fontFamily: 'CenturyGothic',
        textTransform: 'uppercase',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        borderRadius: '10px',
        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)', // Enhanced shadow
        border: '1px solid #dcdcdc', // Subtle border
        boxSizing: 'border-box', // Ensure padding doesn't affect width
        '@media (max-width: 768px)': {
            width: '95%',
        },
    },

    // Row Style
    rowStyle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: '10px',
        marginBottom: '20px',
        '@media (max-width: 768px)': {
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
        },
    },
    // Label Style
    lblStyle: {
        color: '#333333',
        fontSize: '16px',
        fontWeight: 'bold',
        flex: '0 0 180px',
        textAlign: 'left',
        marginRight: '10px',
        fontFamily: 'Lulo',
        lineHeight: '1.5',
        '@media (max-width: 768px)': {
            flex: '1 1 100%',
            marginBottom: '5px',
        },
    },
    // Input Fields
    inputStyle: {
        backgroundColor: '#ffffff',
        border: '1px solid #cccccc',
        borderRadius: '4px',
        height: '40px',
        lineHeight: '1.5',
        padding: '0 10px',
        fontSize: '16px',
        color: '#333333',
        boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.1)',
        width: '100%',
        outline: '2px solid transparent', // Add this line for default outline
        transition: 'outline 0.3s ease', // Smooth transition for focus
        '@media (max-width: 768px)': {
            width: '100%',
            marginBottom: '10px',
        },
        ':focus': {
            outline: '2px solid #3366cc', // Highlight outline on focus
        },
    },
    

    // Checkbox Input
    checkboxInput: {
        width: '20px',
        height: '20px',
        marginRight: '10px',
        verticalAlign: 'middle',
    },

    // Button
    submitBtn: {
        border: '2px solid transparent',
        backgroundColor: '#3366cc', // Blue button
        height: '48px',
        lineHeight: '45px',
        fontSize: '15px',
        padding: '0 30px',
        textAlign: 'center',
        textTransform: 'uppercase',
        color: 'white',
        alignSelf: 'center',
        cursor: 'pointer',
        width: 'auto',
        fontFamily: 'Lulo',
        borderRadius: '4px',
        marginTop: '20px',
        ':hover': {
            backgroundColor: '#2b5cbf',
        },
        '@media (max-width: 768px)': {
            width: '100%', // Full width on smaller screens
        },
    },

    // Headers
    dashText: {
        display: 'inline-block',
        marginTop: '10vh',
        letterSpacing: '0.3em',
        fontSize: '28px', // Slightly larger
        fontFamily: 'Lulo',
        color: '#444444',
    },

    createAcc: {
        textAlign: 'center',
    },

    // Marketing Opt-In Section
    marketingOptInSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between', // Spread content horizontally
        flexWrap: 'nowrap',
        marginTop: '20px',
        '@media (max-width: 768px)': {
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
    },
    marketingOptInLabel: {
        fontSize: '14px',
        lineHeight: '1.5',
        color: '#333333',
        flex: '1 1 auto',
        maxWidth: 'calc(100% - 34px)', // Adjust for checkbox space
    },
    marketingOptInCheckbox: {
        width: '20px',
        height: '20px',
        flexShrink: 0,
    },
};




let nameStyle = Object.assign({}, styles.inputStyle, { width: '137px', textTransform: 'capitalize', '@media(max-width: 320px)': { width: '110px' } });
let passwordStyle = Object.assign({}, styles.inputStyle, { width: '115px', '@media(max-width: 320px)': { width: '98px' } });
let emailStyle = Object.assign({}, styles.inputStyle, { width: '278px', '@media(max-width: 320px)': { width: '210px' } });
let addressStyle = Object.assign({}, styles.inputStyle, { width: '300px' });
let orgStyle = Object.assign({}, styles.inputStyle, { width: '300px' });
let schOrBusStyle = Object.assign({}, styles.inputStyle, { width: '300px' });

class _IndigoRegister extends React.Component<Tgcc.BaseProps, any> {
    state: any = {
        error: "",
        email: "",
        
        firstName: "",
        lastName: "",
        isWaiting: false,
        Schools:null,
        school:null,
        isCollegiate:false,
        Orgs:null,
        org: null,
        address: null,
        city:null,
        St:null,
        zip:null,
        phone:null,
        group:null,
        buyer:"No",
        isBuyer:false,
        smsAllowed:true,
        studentGroup: "No Rep",
        type:"Indigo",
        marketingOptIn: true,
        showOtp: false,
        otpCode: "",
        otpError: "",
        isSendingOtp: false,
        resendAfter: 60,
        resendCountdown: 0,
        isResending: false,
    };

    componentWillMount() {
        this.clearState();
    }
    componentDidMount(){
        var tag = document.getElementById('register');
        tag.scrollIntoView(false);
    }

    componentWillUnmount() {
        // Clear the OTP timer to prevent memory leaks
        if ((this as any)._otpTimer) {
            clearInterval((this as any)._otpTimer);
        }
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    SchoolsLoaded(schools : string[]) {
        this.setState({Schools: schools});
    }
    OrgsLoaded(orgs:string[]){
        this.setState({Orgs:orgs});
    }

    clearState = () => {
        this.setState({Schools: null,school:null,isCollegiate:false,Orgs:null,org:null});       
    }

    failedLogin = (err: any) => {
        this.setState({error: "registration succeeded, but login failed", isWaiting: false});
    }
    

    successfulRegistration = (userData: Tgcc.UserInfo) => {
        // This handler is now used after backend returns token+user
        try {
            const anyData: any = userData as any;
            if (anyData && (anyData.token || anyData.accessToken)) {
                const loginData = anyData;
                Tgcc.successfulIndigoLogin(this.props.dispatch, loginData);
                // Create ghost proof with new login
                let ghostProofData = new Tgcc.UserInfo();
                ghostProofData.email = this.state.email;
                Request.createGhostProof(ghostProofData, loginData,
                    (proof) => { },
                    (error) => { console.error("Failed to create ghost proof", error); }
                );
                this.setState(prev => ({ ...prev, isWaiting: false, showOtp: false }));
                return;
            }
        } catch {}
        // Fallback: just set profile
        this.props.dispatch({ type: Tgcc.StateAction.SetUserInfo, payload: userData });
        this.setState(prev => ({ ...prev, isWaiting: false, showOtp: false }));
    }
    

    failedRegistration = (err: string) => {
        this.setState({error: err, isWaiting: false});
    }

    doRegistration = () => {
        
        if(!this.state.firstName || !this.state.firstName.trim())
            this.setState({error: 'First Name cannot be blank', isWaiting: false});
        else if(!this.state.lastName || !this.state.lastName.trim())
            this.setState({error: 'Last Name cannot be blank', isWaiting: false});
        else if(!this.state.email || !this.state.email.trim())
            this.setState({error: 'Email cannot be blank', isWaiting: false});
        else if(!this.state.address || !this.state.address.trim())
            this.setState({error: 'Address cannot be blank', isWaiting: false});
        else if(!this.state.city || !this.state.city.trim())
            this.setState({error: 'City cannot be blank', isWaiting: false});
        else if(!this.state.St || !this.state.St.trim())
            this.setState({error: 'State cannot be blank', isWaiting: false});
        else if(!this.state.zip || !this.state.zip.trim())
            this.setState({error: 'Zip code cannot be blank', isWaiting: false});
        else if(!this.state.phone || !this.state.phone.trim())
            this.setState({error: 'Phone cannot be blank', isWaiting: false});
        else {
            // Request OTP then show modal
            if (!this.state.email || !this.state.email.trim()) {
                this.setState({ error: 'Email cannot be blank', isWaiting: false });
                return;
            }
            this.setState({ isWaiting: true, isSendingOtp: true, otpError: '' });
            Request.requestRegistrationOtp(
                this.state.email,
                (_res) => {
                    const wait = _res && _res.resendAfterSeconds ? _res.resendAfterSeconds : 60;
                    this.startResendCountdown(wait);
                    this.setState({ isWaiting: false, isSendingOtp: false, showOtp: true, resendAfter: wait });
                },
                (err: string) => this.setState({ error: err, isWaiting: false, isSendingOtp: false })
            );        
        }
    }

    fnameChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({firstName: evt.currentTarget.value});
    }
    marketingOptInChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({ marketingOptIn: evt.currentTarget.checked });
    };

    
    lnameChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({lastName: evt.currentTarget.value});
    }
    emailChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({email: evt.currentTarget.value});
    }

    // passwordless: remove password handlers

    submitOtp = () => {
        if (!this.state.otpCode || this.state.otpCode.trim().length !== 6) {
            this.setState({ otpError: 'Enter the 6-digit code.' });
            return;
        }
        this.setState({ isWaiting: true, otpError: '' });
        var user = new Tgcc.UserInfo;
        user.email = this.state.email;
        user.firstName = this.state.firstName;
        user.lastName = this.state.lastName;
        user.schoolOrBusiness = this.state.school;
        user.studentGroup = this.state.studentGroup
        user.organization = this.state.org;
        user.address = this.state.address;
        user.city = this.state.city;
        user.state = this.state.St;
        user.zip = this.state.zip;
        user.phone = this.state.phone;
        user.smsAllowed = this.state.smsAllowed;
        user.group = this.state.group;
        user.buyer = this.state.buyer;
        user.type = this.state.type;   
        user.marketingOptIn = this.state.marketingOptIn;
        Request.registerUserPasswordless(
            user,
            this.state.otpCode,
            (data: any) => this.successfulRegistration(data as any),
            (err: string) => this.setState({ otpError: err, isWaiting: false })
        );
    }

    closeOtp = () => { this.setState({ showOtp: false }); }

    startResendCountdown = (seconds: number) => {
        this.setState({ resendCountdown: seconds });
        const tick = () => {
            this.setState((prev: any) => ({ resendCountdown: (prev.resendCountdown || 0) - 1 }));
            if ((this.state as any).resendCountdown <= 1) clearInterval((this as any)._otpTimer);
        };
        clearInterval((this as any)._otpTimer);
        ;(this as any)._otpTimer = setInterval(() => {
            this.setState((prev: any) => {
                const next = (prev.resendCountdown || 0) - 1;
                if (next <= 0) {
                    clearInterval((this as any)._otpTimer);
                    return { resendCountdown: 0 };
                }
                return { resendCountdown: next };
            });
        }, 1000);
    }

    resendOtp = () => {
        if ((this.state.resendCountdown || 0) > 0 || this.state.isResending) return;
        this.setState({ isResending: true, otpError: '' });
        Request.requestRegistrationOtp(
            this.state.email,
            (_res) => {
                const wait = _res && _res.resendAfterSeconds ? _res.resendAfterSeconds : 60;
                this.startResendCountdown(wait);
                this.setState({ isResending: false });
            },
            (err: string) => this.setState({ isResending: false, otpError: err })
        );
    }
    checkKeyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doRegistration();
    }
    schoolChanged = (evt: React.FormEvent<HTMLSelectElement>) => {
        this.setState({school:evt.currentTarget.value})
    }
    companyChanged = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({school:evt.currentTarget.value})
    }
    orgChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({org:evt.currentTarget.value})
    }
    studentChanged = (evt: React.FormEvent<HTMLSelectElement>) => {
        this.setState({studentGroup:evt.currentTarget.value})
    }
    grpSizeChg = (evt: React.FormEvent<HTMLSelectElement>) => {
        this.setState({group:evt.currentTarget.value})
    }
    addressChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({address:evt.currentTarget.value})
    }
    cityChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({city:evt.currentTarget.value})
    }
    stateChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({St:evt.currentTarget.value})
    }
    zipChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({zip:evt.currentTarget.value})
    }
     phoneNumberChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({phone:Tgcc.formatPhoneNumber(evt.currentTarget.value)});
    }
    smsAllowedChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({smsAllowed: evt.currentTarget.checked});
    }
    buyerChanged = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({isBuyer:evt.currentTarget.checked});
        if(evt.currentTarget.checked){
            this.setState({buyer:'Yes'});
        } else {
            this.setState({buyer:'No'});
        }
    }
    getDashHeader(){
        return (
            <div style={styles.createAcc} >
                <div style={styles.dashHdrLineR} ></div>
                <h1 style={styles.dashText}>CREATE AN ACCOUNT</h1>
                <div style={styles.dashHdrLineL} ></div>

            </div>
        )
    }
    openLogin = () =>{browserHistory.push(Tgcc.Routes.IndigoLogin)}

    render() {
        var btnElement = this.state.isWaiting ? 
            Tgcc.workingGif
            : <div style={styles.submitBtn} onClick={this.doRegistration}>Submit</div>;
       
        return (
            <div style={styles.container}>
                <div id="register"></div>
                <IndigoHeader />
                {this.getDashHeader()}
                <div style={styles.registerBox}>
                <div style={{
                    ...styles.rowStyle,
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '20px',
                    textAlign: 'center',
                    fontSize: '16px',
                    fontFamily: 'Arial, sans-serif',
                    color: '#555555',
                }}>
                    Already a customer?&nbsp;
                    <a
                        style={{
                            textDecoration: 'none',
                            fontWeight: 'bold',
                            color: '#3366cc',
                            borderBottom: '2px solid transparent',
                            transition: 'color 0.2s, border-color 0.2s',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.color = '#2b5cbf';
                            e.currentTarget.style.borderColor = '#2b5cbf';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.color = '#3366cc';
                            e.currentTarget.style.borderColor = 'transparent';
                        }}
                        onClick={this.openLogin}
                    >
                        Login
                    </a>
                </div>

                    <div style={styles.innerBox}>
                        
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle}>Resort/Store Name</div>                        
                            <input
                                key="resortName"
                                type="text"
                                style={styles.inputStyle}
                                name="SchoolOrBusiness"
                                value={this.state.SchoolOrBusiness}
                                onChange={this.companyChanged}
                            />
                        </div>
    
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle}>Name</div>                        
                            <input
                                key="firstName"
                                autoFocus
                                type="text"
                                style={styles.inputStyle}
                                name="firstName"
                                onChange={this.fnameChanged}
                                onKeyPress={this.checkKeyPressed}
                                placeholder="first name"
                            />
                            <input
                                key="lastName"
                                type="text"
                                style={styles.inputStyle}
                                name="lastName"
                                onChange={this.lnameChanged}
                                onKeyPress={this.checkKeyPressed}
                                placeholder="last name"
                            />
                        </div>                  
                        
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle}>Address</div>
                            <input
                                key="address"
                                type="text"
                                style={styles.inputStyle}
                                name="Address"
                                placeholder="Address"
                                onChange={this.addressChanged}
                            />
                        </div>
    
                        <div style={styles.rowStyle}>
                            <input
                                key="city"
                                type="text"
                                style={styles.inputStyle}
                                name="City"
                                placeholder="City"
                                onChange={this.cityChanged}
                            />
                            <input
                                key="state"
                                type="text"
                                style={styles.inputStyle}
                                name="State"
                                placeholder="ST"
                                onChange={this.stateChanged}
                            />
                            <input
                                key="zip"
                                type="text"
                                style={styles.inputStyle}
                                name="Zip"
                                placeholder="Zip"
                                onChange={this.zipChanged}
                            />
                        </div>
    
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle}>Phone#</div>
                            <input
                                key="phone"
                                type="text"
                                style={styles.inputStyle}
                                name="Phone"
                                placeholder="daytime phone number"
                                onChange={this.phoneNumberChanged}
                            />
                        </div>
    
                    {/* SMS Allowed Section */}
                    <div style={styles.rowStyle}>
                        <label style={styles.lblStyle}>Receive Text Notifications?</label>
                        <div style={{ flex: '1 1 auto', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input
                                key="smsAllowed"
                                type="checkbox"
                                style={styles.checkboxInput}
                                name="smsAllowed"
                                onChange={this.smsAllowedChanged}
                                checked={this.state.smsAllowed}
                            />
                            <span style={styles.marketingOptInLabel}>
                                Get order updates and important info via text.
                                By checking this box, you agree to receive SMS messages from us.
                                Msg & data rates may apply.
                            </span>
                        </div>
                    </div>
    
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle}>Indigo Sales Rep</div>
                            <select
                                key="studentGroup"
                                onChange={this.studentChanged}
                                name="studentGroup"
                                style={styles.inputStyle}
                            >
                                <option key="0" value="No Rep">No Rep</option>
                                <option key="1" value="Devin Householder">Devin Householder</option>
                                <option key="5" value="Steve Parnell">Steve Parnell</option>
                                <option key="7" value="Ashley Ferguson">Ashley Ferguson</option>
                                <option key="9" value="Ben Kilgore">Ben Kilgore</option>
                                <option key="2" value="Beverly Ellison">Beverly Ellison</option>
                                <option key="10" value="House">House or House Account</option>
                            </select>
                        </div>
    
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle}>Email</div>
                            <input
                                key="email"
                                type="text"
                                style={styles.inputStyle}
                                name="email"
                                onChange={this.emailChanged}
                                onKeyPress={this.checkKeyPressed}
                                placeholder="email for login"
                            />
                        </div>
    
                        {/* Passwordless: no password fields */}             
    
                        <div style={{ ...styles.rowStyle, alignItems: 'center', margin: '20px 0' }}>
                            <div
                                style={{
                                    color: Tgcc.Styles.darkTextColor,
                                    fontSize: '14px',
                                    flex: '1 1 auto',
                                    lineHeight: '20px',
                                    fontFamily: 'AveriaSerifLight',
                                    textAlign: 'left',
                                    paddingRight: '10px',
                                }}
                            >
                                Get exclusive discounts, first dibs on sales, and the latest updates via text.
                                By checking this box, you agree to receive promotional SMS messages from us.
                                Msg & data rates may apply. View our{' '}
                                <a
                                    href={Tgcc.Routes.LegalPage}
                                    target="_blank"
                                    style={{
                                        textDecoration: 'underline',
                                        color: Tgcc.Styles.darkTextColor,
                                    }}
                                >
                                    Privacy Policy and Terms
                                </a>.
                            </div>
                            <input
                                key="marketingOptIn"
                                type="checkbox"
                                style={{
                                    ...styles.checkboxStyle,
                                    margin: '0 5px',
                                }}
                                name="marketingOptIn"
                                checked={this.state.marketingOptIn}
                                onChange={(evt) => this.setState({ marketingOptIn: evt.currentTarget.checked })}
                            />
                        </div>
                        {this.state.error && <div style={styles.errorMessage}>{this.state.error}</div>}
                        {btnElement}
                    </div>
                </div> 
                {this.state.showOtp && (
                    <div key="otpOverlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                        <div key="otpDialog" style={{ background: '#fff', padding: '24px', borderRadius: '12px', width: '90%', maxWidth: '500px', boxShadow: '0 16px 40px rgba(0,0,0,0.2)', position: 'relative' }}>
                            <div key="otpCloseX" onClick={this.closeOtp} style={{ position: 'absolute', right: 12, top: 10, cursor: 'pointer', fontSize: '20px', color: '#888' }}>×</div>
                            <h3 style={{ margin: '0 0 8px 0', fontFamily: 'Lulo', letterSpacing: '0.1em' }}>Verify your email</h3>
                            <div style={{ color: '#555', marginBottom: '16px', lineHeight: '20px' }}>
                                We sent a 6‑digit code to <strong>{(this.state.email || '').replace(/(.{2}).+(@)/, '$1***$2')}</strong>.
                                Enter it below to create your account. This code expires in 10 minutes.
                            </div>
                            <input key="otpInput" type="text" maxLength={6} aria-label="6-digit verification code" style={{ ...styles.inputStyle, textAlign: 'center', letterSpacing: '8px', fontSize: '26px', fontFamily: 'monospace' }} value={this.state.otpCode} onChange={(e) => {
                                const v = (e.currentTarget && e.currentTarget.value) ? e.currentTarget.value : '';
                                this.setState({ otpCode: v.replace(/[^0-9]/g, '') });
                            }} onKeyPress={(e) => {
                                if (e.key === 'Enter' && this.state.otpCode && this.state.otpCode.length === 6) {
                                    this.submitOtp();
                                }
                            }} />
                            {this.state.otpError && <div style={styles.errorMessage}>{this.state.otpError}</div>}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '12px', width: '100%' }}>
                                <div>
                                    <button key="otpResend" onClick={this.resendOtp} disabled={(this.state.resendCountdown || 0) > 0 || !!this.state.isResending} style={{ border: 'none', background: 'transparent', color: '#3366cc', cursor: ((this.state.resendCountdown || 0) > 0 || !!this.state.isResending) ? 'default' : 'pointer', textDecoration: 'underline' }}>
                                        {this.state.isResending ? 'Resending…' : (this.state.resendCountdown && this.state.resendCountdown > 0 ? `Resend in ${this.state.resendCountdown}s` : 'Resend code')}
                                    </button>
                                </div>
                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                    <div key="otpCancel" style={{ ...styles.submitBtn, backgroundColor: '#777', whiteSpace: 'nowrap' }} onClick={this.closeOtp}>Cancel</div>
                                    <div key="otpVerify" style={{ ...styles.submitBtn, whiteSpace: 'nowrap', opacity: this.state.otpCode && this.state.otpCode.length === 6 ? 1 : 0.6, pointerEvents: this.state.otpCode && this.state.otpCode.length === 6 ? 'auto' : 'none' }} onClick={this.submitOtp}>Verify</div>
                                </div>
                            </div>
                            <div style={{ color: '#888', marginTop: '10px', fontSize: '12px' }}>Tip: You can paste the entire code. Numbers only.</div>
                        </div>
                    </div>
                )}
            </div>              
        );
    }
    
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var IndigoRegister = connect(mapStateToProps)(Radium(_IndigoRegister));